var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","small":"","text":""},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("Editar")])}
var staticRenderFns = []

export { render, staticRenderFns }